module.exports = __webpack_public_path__ + "static/media/QuickActions1.e3f0d4a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/QuickActions1.gif
// module id = 22
// module chunks = 0